// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconStataptsrusde } from "../../../icons/full/build/icon-stataptsrusde.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const StataptsrusdeIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconStataptsrusde.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  StataptsrusdeIcon.displayName = 'StataptsrusdeIcon';
}

export default StataptsrusdeIcon;